import { Box, Typography } from "@mui/material";
import LoadingComponent from "../../../../../../common/components/LoadingComponent";
import moment from "moment/moment";
import { useAvailableMaxDateL3 } from "../DataProvider/hooks";

export default function AsOfDate({ textOnly = false }) {
    // From L3_rsa_tss_pos
    const { data, isLoading } = useAvailableMaxDateL3();

    if (isLoading) {
        if (textOnly) {
            return "Loading..."
        }
        return <Box md={2} sx={{ marginY: -1, paddingX: 2, display: 'flex', justifyContent: 'end', width: "100%" }} >
            <LoadingComponent />
        </Box>
    }

    if (!data) {
        return null
    }

    const displayText = <>Data as of {moment(data).format('MMMM DD, YYYY')}</>
    if (textOnly) {
        return displayText
    }

    return <Box textAlign="end" width={"100%"} >
        <Typography variant="body1" >
            {displayText}
        </Typography>
    </Box>
}